// extracted by mini-css-extract-plugin
module.exports = {"container":"Welcome_container__30PEN","button":"Welcome_button__2R9O0"};